import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import { statementStyle } from '../Components/Statement';

const showProcedureCode = (d: IDocumentWithTypeV2<'muscleImaging'>) => d.procedureCode && d.procedureCode.length > 0;
const showStatement = (d: IDocumentWithTypeV2<'muscleImaging'>) => d.statement && d.statement.length > 0;

const MuscleImaging = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  const showProcedureCodeHeader = documents.some(d => showProcedureCode(d));
  const showStatementHeader = documents.some(d => showStatement(d));

  return (
    <HistorySection
      headerText={<FormattedMessage id={'imaging.muscleImaging'} />}
      newButton={
        <DocumentCreationButton
          name="muscleImaging"
          text={'imaging.newMuscleImaging'}
          onClick={startEdit({}, 'muscleImaging')}
          width={15}
          height={3}
          fontSize={12}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            {showProcedureCodeHeader && (
              <Item xs={2}>
                <FormattedMessage id="imaging.procedureCode" />
              </Item>
            )}
            {showStatementHeader && (
              <Item xs={3}>
                <FormattedMessage id="imaging.statementText" />
              </Item>
            )}
          </>
        }
        contentFormat={(d): React.JSX.Element => (
          <>
            {showProcedureCodeHeader && <Item xs={2}>{showProcedureCode(d) ? d.procedureCode : ''}</Item>}
            {showStatementHeader && (
              <Item xs={3} style={statementStyle}>
                {showStatement(d) ? d.statement : ''}
              </Item>
            )}
          </>
        )}
        makeDate
        makeControls
        historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'muscleImaging'>[];
  startEdit: StartEdit;
}

export default MuscleImaging;
